<template>
  <section class="wang-luo-ling-shou">
    <PageBlock title="网络零售规模">
      <div class="content">
        <p style="color:#fff;margin: 0">{{retailScaleVo.month}}月</p>
        <div style="display: flex;flex: 1">
          <div class="left">
            <div class="chart">
              <!-- 基于准备好的dom，初始化echarts实例 -->
              <div id="refererChart" ref="chart" style="width: 50%; height:150px;"></div>
              <div>
                <div>
                  订单销量：{{retailScaleVo.orderSales}}万吨
                  <div class="color-content" style="background-color: #FFBA40;"></div>
                </div>
                <div>
                  生产数量：{{retailScaleVo.productionCount}}万吨
                  <div class="color-content" style="background-color: #66FFFF;"></div>
                </div>
              </div>
            </div>
          </div>
          <div class="right">
            <div class="value">{{retailScaleVo.salesAmount}}万元</div>
            <div class="name">
              销售金额
              <img src="../assets/images/xiao-shou.svg" style="opacity: 0.17" alt="">
            </div>
            <div class="text">
              同比销售增长率 <span>{{ retailScaleVo.growthRate }}</span>
            </div>
          </div>
        </div>
      </div>
    </PageBlock>
  </section>
</template>

<script>
import PageBlock from "@/components/page-block.vue";
// 引入 ECharts
import * as echarts from 'echarts';
export default {
  name: 'wang-luo-ling-shou',
  components: {
    PageBlock
  },
  props: {
    retailScaleVo: Object
  },
  watch: {
    retailScaleVo: {
      handler: (val) => {
        this.chart.dispose()
        this.initChart()
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      chart: null
    };
  },
  mounted() {
    this.initChart();
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$refs.chart);
      const option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'horizontal',
          show: false
        },
        series: [
          {
            type: 'pie',
            // radius: '50%',
            data: [
              {
                value: this.retailScaleVo.orderSales,
                name: '订单销量',
                itemStyle: {
                  color: '#FFBA40'
                },
                label: {
                  show: true,
                  position: 'inside'
                }
              },
              {
                value: this.retailScaleVo.productionCount,
                name: '生产数量',
                itemStyle: {
                  color: '#66FFFF'
                },
                label: {
                  show: true,
                  position: 'inside'
                }
              },
            ],
            labelLine: {
              show: false
            }
          }
        ]
      }
      // 设置配置项
      this.chart.setOption(option)
    },
  },
};
</script>

<style scoped lang="scss">
.wang-luo-ling-shou {
  .content{
    padding: 11px;
    border-radius: 12px;
    background: rgba(102, 255, 255, 0.17);
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    .left {
      flex: 1;
      .chart{
        display: flex;
        font-size: 12px;
        color: #fff;
        align-items: center;
      }
      .color-content{
        width: 10px;
        height: 10px;
        border-radius: 50%;
      }
    };
    .right{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .value{
        font-size: 20.93px;
        font-weight: 350;
        line-height: 20.93px;
        color: #FFBA40;
      }
      .name{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #fff;
        gap: 12px;
        position:relative;
        padding-bottom: 20px;
        >img{
          position: absolute;
          bottom: 0;
        }
        //background: url("../assets/images/xiao-shou.svg") no-repeat center center / 100px;
      }
      .text{
        font-size: 8px;
        color: #fff;
        margin-top: 6px;
        >span{
          color: #7BF9FF;
        }
      }
    }
  }
}
</style>
